import React from "react";
import { RolePermissionForm } from "./rolePermissionForm";
import { RolePermissionService } from "./rolePermissionService";

interface RolePermissionContainerProps {
  id?: string;
  onHide: () => void;
  onSave: (values: any) => void;
}

export const RolePermissionContainer = (
  props: RolePermissionContainerProps
) => {
  const rolePermissionslookupQuery =
    RolePermissionService.getRolePermissionLookupsQuery();

  const rolePermissionQuery = RolePermissionService.getRolePermissionQuery(
    props.id ?? undefined
  );

  return (
    <RolePermissionForm
      data={rolePermissionQuery?.data}
      lookups={rolePermissionslookupQuery?.data}
      show={true}
      onHide={props.onHide}
      onSave={props.onSave}
      loading={
        rolePermissionslookupQuery.isLoading || rolePermissionQuery.isLoading
      }
    />
  );
};
